export default "__VITE_ASSET__B15JQU_T__"